import axios from "axios";
import {RunQuotePopup} from "components/RunQuotePopup";
import {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import styles from "./styles.module.scss";

export function CustomersHeader() {
  const {id} = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [company, setCompany] = useState();
  const [isModalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    (async function () {
      try {
        const companyData = await axios.get("/api/company/" + id);
        setCompany(companyData.data.data);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  const handleContinue = () => {
    setModalOpen(false);
    navigate("/app/quote/run", {
      state: {
        data: {
          company_id: id,
        },
      },
    });
  };

  const handleCancel = () => {
    setModalOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.menu}>
        <div
          onClick={() => {
            if (
              location.pathname.includes("/company") &&
              !(
                location.pathname.includes("/info") ||
                location.pathname.includes("/contacts")
              )
            ) {
              window.location.href = `/app/company/${id}/info`;
            }
          }}
          className={
            location.pathname.includes("/company") &&
            (location.pathname.includes("/info") ||
              location.pathname.includes("/contacts"))
              ? styles.itemActive
              : styles.item
          }
        >
          Company
        </div>
        <div
          onClick={() => {
            if (
              location.pathname.includes("/company") &&
              !location.pathname.includes("/policies")
            ) {
              window.location.href = `/app/company/${id}/policies`;
            }
          }}
          className={
            location.pathname.includes("/company") &&
            location.pathname.includes("/policies")
              ? styles.itemActive
              : styles.item
          }
        >
          Policies
        </div>
        <div
          onClick={() => {
            if (
              location.pathname.includes("/company") &&
              !location.pathname.includes("/endorsements")
            ) {
              window.location.href = `/app/company/${id}/endorsements`;
            }
          }}
          className={
            location.pathname.includes("/company") &&
            location.pathname.includes("/endorsements")
              ? styles.itemActive
              : styles.item
          }
        >
          Endorsements
        </div>
        <div
          onClick={() => {
            if (
              location.pathname.includes("/company") &&
              !location.pathname.includes("/certificates")
            ) {
              window.location.href = `/app/company/${id}/certificates`;
            }
          }}
          className={
            location.pathname.includes("/company") &&
            location.pathname.includes("/certificates")
              ? styles.itemActive
              : styles.item
          }
        >
          Certificates
        </div>
        <div
          onClick={() => {
            if (
              location.pathname.includes("/company") &&
              !location.pathname.includes("/quotes")
            ) {
              window.location.href = `/app/company/${id}/quotes`;
            }
          }}
          className={
            location.pathname.includes("/company") &&
            location.pathname.includes("/quotes")
              ? styles.itemActive
              : styles.item
          }
        >
          Quotes
        </div>
        <div
          onClick={() => {
            if (
              location.pathname.includes("/company") &&
              !location.pathname.includes("/documents")
            ) {
              window.location.href = `/app/company/${id}/documents`;
            }
          }}
          className={
            location.pathname.includes("/company") &&
            location.pathname.includes("/documents")
              ? styles.itemActive
              : styles.item
          }
        >
          Documents
        </div>
        <div
          onClick={() => {
            if (
              location.pathname.includes("/company") &&
              !location.pathname.includes("/drivers")
            ) {
              window.location.href = `/app/company/${id}/drivers`;
            }
          }}
          className={
            location.pathname.includes("/company") &&
            location.pathname.includes("/drivers")
              ? styles.itemActive
              : styles.item
          }
        >
          Drivers
        </div>
        <div
          onClick={() => {
            if (
              location.pathname.includes("/company") &&
              !location.pathname.includes("/vehicles")
            ) {
              window.location.href = `/app/company/${id}/vehicles`;
            }
          }}
          className={
            location.pathname.includes("/company") &&
            location.pathname.includes("/vehicles")
              ? styles.itemActive
              : styles.item
          }
        >
          Vehicles
        </div>
        <div
          onClick={() => {
            if (
              location.pathname.includes("/company") &&
              !location.pathname.includes("/trailers")
            ) {
              window.location.href = `/app/company/${id}/trailers`;
            }
          }}
          className={
            location.pathname.includes("/company") &&
            location.pathname.includes("/trailers")
              ? styles.itemActive
              : styles.item
          }
        >
          Trailers
        </div>
        <div
          onClick={() => {
            if (
              location.pathname.includes("/company") &&
              !location.pathname.includes("/log")
            ) {
              window.location.href = `/app/company/${id}/log`;
            }
          }}
          className={
            location.pathname.includes("/company") &&
            location.pathname.includes("/log")
              ? styles.itemActive
              : styles.item
          }
        >
          Activity Log
        </div>
        <div
          onClick={() => {
            if (location.pathname.includes("/company") && !location.pathname.includes("/notes")) {
              window.location.href = `/app/company/${id}/notes`;
            }
          }}
          className={
            location.pathname.includes("/company") && location.pathname.includes("/notes")
              ? styles.itemActive
              : styles.item
          }
        >
          Notes
        </div>
      </div>
      {isModalOpen && (
        <RunQuotePopup onContinue={handleContinue} onCancel={handleCancel}/>
      )}
      <div className={styles.buttonWrapper}>
        <div
          onClick={() => {
            if (location.pathname.includes("/company")) {
              window.open(
                `https://safer.fmcsa.dot.gov/query.asp?searchtype=ANY&query_type=queryCarrierSnapshot&query_param=USDOT&query_string=${company.dot_number}`
              );
            }
          }}
          className={styles.blue_button}
        >
          FMCSA
        </div>
        <div
          onClick={() => {
            if (location.pathname.includes("/company")) {
              window.open(
                `https://ai.fmcsa.dot.gov/SMS/Carrier/${company.dot_number}/Overview.aspx`
              );
            }
          }}
          className={styles.blue_button}
        >
          SMS
        </div>
        <div
          onClick={() => {
            navigate("/app/quote/run", {
              state: {
                data: {
                  company_id: id,
                },
              },
            });
          }}
          className={styles.button}
        >
          Run quote
        </div>
      </div>
    </header>
  );
}
